/* THE LIBRARY FROM ANY CHAT — her call, 2026-10-09: the Library belongs to the
 * person, every tier gets it, and it is "literally this button" (Momentum's
 * NotebookPen beside Light panel) on the Ideation and Accelerator screens too.
 *
 * It opens OVER where she is, with an ✕, rather than as a sidebar row: a row
 * would swap her chat out for the Library (and on a phone close the nav), and
 * the Library is a thing she reaches FOR mid-conversation, not a place she
 * goes. Spec: docs/library-shared-layer.md.
 *
 * The same `Library` component Momentum renders — its store and RLS were never
 * tied to a tier, and `momentum/tokens.js` is all global canvas variables.
 *
 * zIndex 90: under ConfirmDialog (100) and Momentum's pop-ups (120), which the
 * Library opens on top of itself (delete an item, pick a picture).
 */
import { useEffect } from "react";
import { NotebookPen, X } from "lucide-react";
import { Library } from "./momentum/library";

/** The header button. Teal while the Library is open, as in Momentum. */
export function LibraryButton({ open, onClick }) {
  return (
    <button onClick={onClick} title="Library" aria-label="Library" aria-pressed={!!open}
      style={{ background: "none", border: "1px solid var(--chrome-border-strong)", borderRadius: 8, cursor: "pointer",
        color: open ? "var(--chrome-accent)" : "var(--chrome-text)",
        borderColor: open ? "var(--chrome-accent-line)" : "var(--chrome-border-strong)",
        padding: "7px 10px", display: "flex", alignItems: "center", flexShrink: 0 }}>
      <NotebookPen size={16} />
    </button>
  );
}

export function LibraryOverlay({ onClose, isMobile = false, start = null }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div role="dialog" aria-modal="true" aria-label="Library"
      style={{ position: "fixed", inset: 0, zIndex: 90, background: "var(--bg-primary)", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: isMobile ? "10px 12px" : "14px 22px", flexShrink: 0 }}>
        <button onClick={onClose} aria-label="Close the Library" title="Close"
          style={{ background: "none", border: "1px solid var(--border-strong)", borderRadius: 8, cursor: "pointer",
            color: "var(--text-primary)", minWidth: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <X size={18} />
        </button>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: isMobile ? "0 16px 44px" : "0 32px 56px", minHeight: 0 }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <Library isMobile={isMobile} crumb={null} start={start} />
        </div>
      </div>
    </div>
  );
}
